import React from 'react';
import { useData } from 'context/data.context';
import { YEAR_OPTIONS } from 'utilities/global.variables';

const ForecastYearsCard = () => {
  const { networthProjected } = useData();

  return (
    <div className="flex col center">
      <div className="button-group regular bold" role="group">
        {YEAR_OPTIONS.map((y) => (
          <React.Fragment key={y}>
            <input
              type="radio"
              className="button-item"
              name="forecast"
              id={`${y} years`}
              value={y}
              checked={networthProjected.years === y}
              onChange={(e) => networthProjected.setYears(Number(e.target.value))}
            />
            <label htmlFor={`${y} years`}>{y}y</label>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ForecastYearsCard;
